<template>
  <div class="home">
    <VideoList class="marginal"></VideoList>
  </div>
</template>

<script>
import VideoList from "@/components/VideoList.vue";

export default {
  name: "home",
  components: {
    VideoList,
  },
};
</script>
